import configJson from "../config/config.json"
import industryCode from "../../static/json/industry_code.json"
import newsTypeLists from '../../static/json/news_labels.json'
import httpManager from './common'
import v from "validator";
import Cookies from 'js-cookie'

let getESGReportInfo = async () => {
  if (sessionStorage.getItem('report_list') === null ||
      sessionStorage.getItem('report_month_list') === null ||
      sessionStorage.getItem('report_annual_list') === null) {
    let result = await httpManager('esg_report_date_list')
    if (result.status === 200) {
      sessionStorage.setItem('report_list', JSON.stringify(result.data.data))
    }
    let result1 = await httpManager('esg_report_date_monthly')
    if (result1.status === 200) {
      sessionStorage.setItem('report_month_list', JSON.stringify(result1.data.data))
    }
    let result2 = await httpManager('esg_report_date_annual')
    if (result2.status === 200) {
      sessionStorage.setItem('report_annual_list', JSON.stringify(result2.data.data))
    }
    sessionStorage.setItem('industry_code', industryCode)
  }
  return {
    'report_list':JSON.parse(sessionStorage.getItem('report_list')),
    'report_month_list':JSON.parse(sessionStorage.getItem('report_month_list')),
    'report_annual_list':JSON.parse(sessionStorage.getItem('report_annual_list')),
    'industry_code': industryCode
  }
}

let getESGRatingIndicators = async () => {
  if (sessionStorage.getItem('rating_tree_zh') === null ||
      sessionStorage.getItem('rating_tree_en') === null ||
      sessionStorage.getItem('month_tree_en') === null ||
      sessionStorage.getItem('annual_tree_en') === null ||
      sessionStorage.getItem('indicators_unit_en') === null||
      sessionStorage.getItem('month_tree_zh') === null ||
      sessionStorage.getItem('annual_tree_zh') === null ||
      sessionStorage.getItem('indicators_unit_zh') === null ||
      sessionStorage.getItem('data_type') === null ||
      sessionStorage.getItem('rating_indicator_map') === null) {
    let split_str = '='
    let result = await httpManager('esg_rating_info')
    if (result.status === 200) {
      let data = result.data.data
      let midData_zh = {}
      let midData_en = {}
      let rating_indicator_map = {}
      if(sessionStorage.getItem('rating_indicator_map')){
        rating_indicator_map = JSON.parse(sessionStorage.getItem('rating_indicator_map'))
      }
      data.forEach(function (k) {
        let zh = "ESG#esg"+split_str+k['dimension1']+"#"+k['dimension1_en']+split_str+k['dimension2']+"#"+k['dimension2_en']
        createTreeNode(midData_zh, zh, split_str)
        let en = "ESG#esg"+split_str+k['dimension1_en']+split_str+k['dimension2_en']
        createTreeNode(midData_en, en, split_str)
        if(!(k['dimension1_en'].toLowerCase().replaceAll(" ", "_") in rating_indicator_map)){
          rating_indicator_map[k['dimension1_en'].toLowerCase().replaceAll(" ", "_")] = {"zh": k['dimension1'], "en": k['dimension1_en']}
        }
        if(!(k['dimension2_en'].toLowerCase().replaceAll(" ", "_") in rating_indicator_map)){
          rating_indicator_map[k['dimension2_en'].toLowerCase().replaceAll(" ", "_")] = {"zh": k['dimension2'], "en": k['dimension2_en']}
        }
      })
      if(!("esg" in rating_indicator_map)){
          rating_indicator_map["esg"] = {"zh": "ESG", "en": "ESG"}
        }
      shuffleTree(midData_zh)
      let rating_tree_zh = []
      for (let k in midData_zh) {
        rating_tree_zh.push(midData_zh[k])
      }
      shuffleTree(midData_en)
      let rating_tree_en = []
      for (let k in midData_en) {
        rating_tree_en.push(midData_en[k])
      }
      sessionStorage.setItem('rating_tree_zh', JSON.stringify(rating_tree_zh))
      sessionStorage.setItem('rating_tree_en', JSON.stringify(rating_tree_en))
      sessionStorage.setItem('rating_indicator_map', JSON.stringify(rating_indicator_map))
    }
    let params = new Map()
    params.set("type", "Monthly")
    params.set("lang", "zh")
    let result1 = await httpManager('esg_indicators_info',params)
    if (result1.status === 200) {
      let data = result1.data.data
      let midData = {}
      let rating_indicator_map = {}
      if(sessionStorage.getItem('rating_indicator_map')){
        rating_indicator_map = JSON.parse(sessionStorage.getItem('rating_indicator_map'))
      }
      let unit = {}
      if(sessionStorage.getItem('indicators_unit_zh')){
        unit = JSON.parse(sessionStorage.getItem('indicators_unit_zh'))
      }
      data.forEach(function (k) {
        let s = k['dimension1']+split_str+k['dimension2']+split_str+k['name']+"#"+k['indicator']
        unit[k['name']] = k['unit']
        createTreeNode(midData, s, split_str)
        if(!(k['indicator'].toLowerCase().replaceAll(" ", "_") in rating_indicator_map)){
          rating_indicator_map[k['indicator'].toLowerCase().replaceAll(" ", "_")] = {"zh": null, "en": null}
        }
        rating_indicator_map[k['indicator'].toLowerCase().replaceAll(" ", "_")]["zh"] = k['name']
      })
      shuffleTree(midData)
      let month_tree = []
      for (let k in midData) {
        month_tree.push(midData[k])
      }
      sessionStorage.setItem('month_tree_zh', JSON.stringify(month_tree))
      sessionStorage.setItem('indicators_unit_zh', JSON.stringify(unit))
      sessionStorage.setItem('rating_indicator_map', JSON.stringify(rating_indicator_map))
    }
    params.set("lang", "en")
    let result2 = await httpManager('esg_indicators_info',params)
    if (result2.status === 200) {
      let data = result2.data.data
      let midData = {}
      let rating_indicator_map = {}
      if(sessionStorage.getItem('rating_indicator_map')){
        rating_indicator_map = JSON.parse(sessionStorage.getItem('rating_indicator_map'))
      }
      let data_type = {}
      if(sessionStorage.getItem('data_type')){
        data_type = JSON.parse(sessionStorage.getItem('data_type'))
      }
      let unit = {}
      if(sessionStorage.getItem('indicators_unit_en')){
        unit = JSON.parse(sessionStorage.getItem('indicators_unit_en'))
      }

      data.forEach(function (k) {
        let s = k['dimension1']+split_str+k['dimension2']+split_str+k['name']+"#"+k['indicator']
        unit[k['name']] = k['unit']
        data_type[k['name']] = k['data_type']
        createTreeNode(midData, s, split_str)
        if(!(k['indicator'].toLowerCase().replaceAll(" ", "_") in rating_indicator_map)){
          rating_indicator_map[k['indicator'].toLowerCase().replaceAll(" ", "_")] = {"zh": null, "en": null}
        }
        rating_indicator_map[k['indicator'].toLowerCase().replaceAll(" ", "_")]["en"] = k['name']
      })
      shuffleTree(midData)
      let month_tree = []
      for (let k in midData) {
        month_tree.push(midData[k])
      }
      sessionStorage.setItem('month_tree_en', JSON.stringify(month_tree))
      sessionStorage.setItem('indicators_unit_en', JSON.stringify(unit))
      sessionStorage.setItem('data_type', JSON.stringify(data_type))
      sessionStorage.setItem('rating_indicator_map', JSON.stringify(rating_indicator_map))
    }
    params.set("type", "Yearly")
    params.set("lang", "zh")
    let result3 = await httpManager('esg_indicators_info')
    if (result3.status === 200) {
      let data = result3.data.data
      let midData = {}
      let rating_indicator_map = {}
      if(sessionStorage.getItem('rating_indicator_map')){
        rating_indicator_map = JSON.parse(sessionStorage.getItem('rating_indicator_map'))
      }
      let unit = {}
      if(sessionStorage.getItem('indicators_unit_zh')){
        unit = JSON.parse(sessionStorage.getItem('indicators_unit_zh'))
      }
      data.forEach(function (k) {
        let s = k['dimension1']+split_str+k['dimension2']+split_str+k['name']+"#"+k['indicator']
        unit[k['name']] = k['unit']
        createTreeNode(midData, s, split_str)
        if(!(k['indicator'].toLowerCase().replaceAll(" ", "_") in rating_indicator_map)){
          rating_indicator_map[k['indicator'].toLowerCase().replaceAll(" ", "_")] = {"zh": null, "en": null}
        }
        rating_indicator_map[k['indicator'].toLowerCase().replaceAll(" ", "_")]["zh"] = k['name']
      })
      shuffleTree(midData)
      let annual_tree = []
      for (let k in midData) {
        annual_tree.push(midData[k])
      }
      sessionStorage.setItem('annual_tree_zh', JSON.stringify(annual_tree))
      sessionStorage.setItem('indicators_unit_zh', JSON.stringify(unit))
      sessionStorage.setItem('rating_indicator_map', JSON.stringify(rating_indicator_map))
    }
    params.set("lang", "en")
    let result4 = await httpManager('esg_indicators_info')
    if (result4.status === 200) {
      let data = result4.data.data
      let midData = {}
      let data_type = {}
      let rating_indicator_map = {}
      if(sessionStorage.getItem('rating_indicator_map')){
        rating_indicator_map = JSON.parse(sessionStorage.getItem('rating_indicator_map'))
      }
      if(sessionStorage.getItem('data_type')){
        data_type = JSON.parse(sessionStorage.getItem('data_type'))
      }
      let unit = {}
      if(sessionStorage.getItem('indicators_unit_en')){
        unit = JSON.parse(sessionStorage.getItem('indicators_unit_en'))
      }
      data.forEach(function (k) {
        let s = k['dimension1']+split_str+k['dimension2']+split_str+k['name']+"#"+k['indicator']
        unit[k['name']] = k['unit']
        data_type[k['name']] = k['data_type']
        createTreeNode(midData, s, split_str)
        if(!(k['indicator'].toLowerCase().replaceAll(" ", "_") in rating_indicator_map)){
          rating_indicator_map[k['indicator'].toLowerCase().replaceAll(" ", "_")] = {"zh": null, "en": null}
        }
        rating_indicator_map[k['indicator'].toLowerCase().replaceAll(" ", "_")]["en"] = k['name']
      })
      shuffleTree(midData)
      let annual_tree = []
      for (let k in midData) {
        annual_tree.push(midData[k])
      }
      sessionStorage.setItem('annual_tree_en', JSON.stringify(annual_tree))
      sessionStorage.setItem('indicators_unit_en', JSON.stringify(unit))
      sessionStorage.setItem('data_type', JSON.stringify(data_type))
      sessionStorage.setItem('rating_indicator_map', JSON.stringify(rating_indicator_map))
    }
  }
  return {
    'rating_tree_en':JSON.parse(sessionStorage.getItem('rating_tree_en')),
    'month_tree_en':JSON.parse(sessionStorage.getItem('month_tree_en')),
    'annual_tree_en':JSON.parse(sessionStorage.getItem('annual_tree_en')),
    'rating_tree_zh':JSON.parse(sessionStorage.getItem('rating_tree_zh')),
    'month_tree_zh':JSON.parse(sessionStorage.getItem('month_tree_zh')),
    'annual_tree_zh':JSON.parse(sessionStorage.getItem('annual_tree_zh')),
    'indicators_unit_zh':JSON.parse(sessionStorage.getItem('indicators_unit_zh')),
    'indicators_unit_en':JSON.parse(sessionStorage.getItem('indicators_unit_en')),
    'indicators_data_type':JSON.parse(sessionStorage.getItem('data_type')),
    'rating_indicator_map':JSON.parse(sessionStorage.getItem('rating_indicator_map')),
  }
}

let getGics = async (key='gics_code') => {
  if(sessionStorage.getItem(key)===null) {
    let params = new Map()
    params.set('type', 'gics')
    let result = await httpManager('gics_industry', params)
    if(result.status===200){
      let data = result.data.data
      let re = {}
      let column_zh = []
      let column_en = []
      let midData_zh = {}
      let midData_en = {}
      let split_str = "-"
      for (let i in data) {
        let s_en = data[i].industry_name_en_level_1+"#"+data[i].industry_code_level_1+split_str+data[i].industry_name_en_level_4+"#"+data[i].industry_code_level_4+"#"+data[i].level_1_valid+"#"+data[i].level_4_valid
        let s_zh = data[i].industry_name_cn_level_1+"#"+data[i].industry_code_level_1+split_str+data[i].industry_name_cn_level_4+"#"+data[i].industry_code_level_4+"#"+data[i].level_1_valid+"#"+data[i].level_4_valid
        createTreeNode(midData_en, s_en, split_str)
        createTreeNode(midData_zh, s_zh, split_str)
        re[data[i].industry_code_level_4] = {"zh":data[i].industry_name_cn_level_4, "en":data[i].industry_name_en_level_4,}
        if(!(data[i].industry_code_level_1 in re))
          re[data[i].industry_code_level_1] = {"zh":data[i].industry_name_cn_level_1, "en":data[i].industry_name_en_level_1,}
        column_en[i] = {
          "major_industry": data[i].industry_name_en_level_1,
          "major_industry_code": data[i].industry_code_level_1,
          "sub_industry": data[i].industry_name_en_level_4,
          "sub_industry_code": data[i].industry_code_level_4,
          "major_industry_valid": data[i].level_1_valid,
          "sub_industry_valid": data[i].level_4_valid
        }
        column_zh[i] = {
          "major_industry": data[i].industry_name_cn_level_1,
          "major_industry_code": data[i].industry_code_level_1,
          "sub_industry": data[i].industry_name_cn_level_4,
          "sub_industry_code": data[i].industry_code_level_4,
          "major_industry_valid": data[i].level_1_valid,
          "sub_industry_valid": data[i].level_4_valid
        }
      }
      shuffleTree(midData_en)
      let gics_tree_en = []
      for (let k in midData_en) {
        gics_tree_en.push(midData_en[k])
      }
      shuffleTree(midData_zh)
      let gics_tree_zh = []
      for (let k in midData_zh) {
        gics_tree_zh.push(midData_zh[k])
      }
      sessionStorage.setItem('gics_tree_en', JSON.stringify(gics_tree_en))
      sessionStorage.setItem('gics_tree_zh', JSON.stringify(gics_tree_zh))
      sessionStorage.setItem('gics_columns_zh', JSON.stringify(column_zh))
      sessionStorage.setItem('gics_columns_en', JSON.stringify(column_en))
      sessionStorage.setItem('gics_code', JSON.stringify(re))
    }
  }
  return JSON.parse(sessionStorage.getItem(key))
}


let getIndustryGics = async (key='gics_industry_code', type) => {
  if(sessionStorage.getItem(key)===null) {
    let params = new Map()
    params.set('type', type)
    let result = await httpManager('gics_industry', params)
    if(result.status===200){
      let data = result.data.data
      let re = {}
      let column_zh = []
      let column_en = []
      let midData_zh = {}
      let midData_en = {}
      let split_str = "-"
      for (let i in data) {
        let s_en = data[i].industry_name_en_level_1+"#"+data[i].industry_code_level_1+split_str+data[i].industry_name_en_level_2+"#"+data[i].industry_code_level_2+split_str+data[i].industry_name_en_level_3+"#"+data[i].industry_code_level_3+split_str+data[i].industry_name_en_level_4+"#"+data[i].industry_code_level_4
        let s_zh = data[i].industry_name_cn_level_1+"#"+data[i].industry_code_level_1+split_str+data[i].industry_name_cn_level_2+"#"+data[i].industry_code_level_2+split_str+data[i].industry_name_cn_level_3+"#"+data[i].industry_code_level_3+split_str+data[i].industry_name_cn_level_4+"#"+data[i].industry_code_level_4
        createTreeNode(midData_en, s_en, split_str)
        createTreeNode(midData_zh, s_zh, split_str)
        re[data[i].industry_code_level_4] = {"zh":data[i].industry_name_cn_level_4, "en":data[i].industry_name_en_level_4,}
        if(!(data[i].industry_code_level_3 in re)) re[data[i].industry_code_level_3] = {"zh":data[i].industry_name_cn_level_3, "en":data[i].industry_name_en_level_3,}
        if(!(data[i].industry_code_level_2 in re)) re[data[i].industry_code_level_2] = {"zh":data[i].industry_name_cn_level_2, "en":data[i].industry_name_en_level_2,}
        if(!(data[i].industry_code_level_1 in re)) re[data[i].industry_code_level_1] = {"zh":data[i].industry_name_cn_level_1, "en":data[i].industry_name_en_level_1,}
        column_en[i] = {
          "industry_name_en_level_1": data[i].industry_name_en_level_1,
          "industry_code_level_1": data[i].industry_code_level_1,
          "industry_name_en_level_2": data[i].industry_name_en_level_2,
          "industry_code_level_2": data[i].industry_code_level_2,
          "industry_name_en_level_3": data[i].industry_name_en_level_3,
          "industry_code_level_3": data[i].industry_code_level_3,
          "industry_name_en_level_4": data[i].industry_name_en_level_4,
          "industry_code_level_4": data[i].industry_code_level_4,
        }
        column_zh[i] = {
          "industry_name_cn_level_1": data[i].industry_name_cn_level_1,
          "industry_code_level_1": data[i].industry_code_level_1,
          "industry_name_cn_level_2": data[i].industry_name_cn_level_2,
          "industry_code_level_2": data[i].industry_code_level_2,
          "industry_name_cn_level_3": data[i].industry_name_cn_level_3,
          "industry_code_level_3": data[i].industry_code_level_3,
          "industry_name_cn_level_4": data[i].industry_name_cn_level_4,
          "industry_code_level_4": data[i].industry_code_level_4,
        }
      }
      shuffleTree(midData_en)
      let gics_tree_en = []
      for (let k in midData_en) {
        gics_tree_en.push(midData_en[k])
      }
      shuffleTree(midData_zh)

      let gics_tree_zh = []
      for (let k in midData_zh) {
        gics_tree_zh.push(midData_zh[k])
      }
      sessionStorage.setItem(`${type}_industry_tree_en`, JSON.stringify(gics_tree_en))
      sessionStorage.setItem(`${type}_industry_tree_zh`, JSON.stringify(gics_tree_zh))
      sessionStorage.setItem(`${type}_industry_columns_zh`, JSON.stringify(column_zh))
      sessionStorage.setItem(`${type}_industry_columns_en`, JSON.stringify(column_en))
      sessionStorage.setItem(`${type}_industry_code`, JSON.stringify(re))
    }
  }
  return JSON.parse(sessionStorage.getItem(key))
}


let getNEIndustry = async (key='nei_code') => {
  if(sessionStorage.getItem(key)===null) {
    let result = await httpManager('national_economic')
    if(result.status === 200) {
      let industries = []
      let data = result.data.data
      sessionStorage.setItem('nei_code_industry', JSON.stringify(data))
      for(let i in data) {
        if(data[i].class_1 && !data[i].class_2){
          let parent = {label: data[i].name, children: [], value: data[i].code}
          industries.push(parent)
        }
      }
      industries.sort((a,b) => {
        return a.code<b.code?-1:1
      })
      let temp = []
      for (let i in industries) {
        if(!temp[i] || temp[i-1].label !== industries[i].label) temp.push(industries[i])
      }
      industries = temp

      for(let i in data){
        let str = data[i].class_1
        if(data[i].class_1 && data[i].class_2){
          let child = {label: data[i].name, value: data[i].code}
          for(let j in industries) {
            if(industries[j].value === str) industries[j].children.push(child)
          }
        }
      }
      sessionStorage.setItem('nei_code', JSON.stringify(industries))
    }
  }
  return JSON.parse(sessionStorage.getItem(key))
}


let createTreeNode = (tree, nodestr, split_str='-', label_value_split='#')=>{
  if(!tree){
    tree = {}
  }
  let nodeArray = nodestr.split(split_str)
  let product_type = nodeArray[0]
  if(product_type in tree){

  }else{
    if(product_type.indexOf(label_value_split)!=-1){
      let o = product_type.split(label_value_split)
      tree[product_type] = {
          value: o[1],
          label: o[0],
          children: {}
        }
      }else{
        tree[product_type] = {
          value: product_type,
          label: product_type,
          children: {}
        }
      }

  }
  if(nodestr.indexOf(split_str)===-1){

  }else{
    createTreeNode(tree[product_type].children, nodestr.substring(nodestr.indexOf(split_str)+1), split_str)
  }
}
let shuffleTree = (tree) => {
  let midstack = []
  for(let i in tree){
    midstack.push(tree[i])
  }
  while(midstack.length != 0){
    let node = midstack.pop()
    let temp = []
    for(let j in node.children){
      midstack.push(node.children[j])
      temp.push(node.children[j])
    }
    if(temp.length != 0) {
      node.children = temp
    }else{
      delete node.children
    }
  }
}
let getProductType = async () => {
  if(sessionStorage.getItem('product_type')===null) {
    let result = await httpManager('sc_product_types')
    if(result.status===200){
      let data = result.data.data
      let midData = {}
      data.forEach(function (k) {
        let product_type = k['product_type']
        createTreeNode(midData, product_type)
      })
      shuffleTree(midData)
      let product_types = []
      for (let k in midData) {
        product_types.push(midData[k])
      }
      sessionStorage.setItem('product_type', JSON.stringify(product_types))
    }
  }
  return JSON.parse(sessionStorage.getItem('product_type'))
}

let createReportYear = () => {
  let report_year_now = configJson.reportYear
  let report_years = Array.from(Array(14), (v,k) =>report_year_now - k)
  let report_options = []
  report_years.slice(0,-5).forEach((year)=>{
    report_options.push({label: year+'', value: year})
  })
  let esg_report_years = Array.from(Array(8), (v,k) =>configJson.esgReportYear - k)
  return {
    "report_year_now": report_year_now,
    "report_options": report_options,
    "report_years": report_years,
    "esg_report_years": esg_report_years,
    "esg_report_month": getESGReportInfo,
    "gics": getGics,
    "gics_industry": getIndustryGics,
    "national_economic": getNEIndustry,
    "esg_meta": getESGRatingIndicators,
    "getReport":(report, duration)=>{let start=parseInt(report_year_now)-parseInt(report)
      return report_years.slice(start, start + parseInt(duration))}
  }
}

let metaData = {"product_type": getProductType}

let changeOaid  = async (id) => {
  if(v.isUUID(id)){
    return id
  }else {
    let params = new Map()
    params.set('keyword', id)
    let result = await httpManager('entity_search', params)
    if (result.status === 200) {
      let oaid = result.data[0].oa_id
      return oaid
    }
  }
}


let entityOaid = {"oaid": changeOaid}

let timestampToDate = (timestamp, type = false) => {
  const fullTime = new Date(timestamp)
  const year = fullTime.getFullYear()
  const month = (fullTime.getMonth() + 1) < 10 ? '0' + (fullTime.getMonth() + 1) : (fullTime.getMonth() + 1)
  const day = (fullTime.getDate()) < 10 ? '0' + (fullTime.getDate()) : (fullTime.getDate())
  const hours = (fullTime.getHours()) < 10 ? '0' + (fullTime.getHours()) : (fullTime.getHours())
  const minutes = (fullTime.getMinutes()) < 10 ? '0' + (fullTime.getMinutes()) : (fullTime.getMinutes())
  const seconds = (fullTime.getSeconds()) < 10 ? '0' + (fullTime.getSeconds()) : (fullTime.getSeconds())
  return type === false ? `${year}-${month}-${day}` : `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}
// 三个数字逗号相隔
let toThousands = (num) => {
  var num = (num || 0).toString(), result = ''
  while (num.length > 3) {
    result = ',' + num.slice(-3) + result
    num = num.slice(0, num.length - 3)
  }
  if (num) { result = num + result }
  return result
}

let dealNewsTypeLists =  (val) => {
  let str = ''
  let locale = Cookies.get('locale') || 'zh'
  if (val === 'A') {
    newsTypeLists[locale].forEach(item => {
      item.children.forEach(el => {
        str += `${el.value},`
      });
    });
    str = str.substring(0, str.length - 1)
  } else if (['E', 'G', 'S'].includes(val)) {
    newsTypeLists[locale].filter(item => {
      return item.value == val
    })[0].children.forEach(el => {
      str += `${el.value},`
    })
    str = str.substring(0, str.length - 1)
  } else {
    str = val
  }
  return str
}

let reportYear = createReportYear()
export {reportYear as reportYear, metaData, entityOaid, toThousands as toThousands, timestampToDate, dealNewsTypeLists}



// WEBPACK FOOTER //
// ./src/util/util.js